module.exports = __webpack_public_path__ + "img/m-daishenpi.a49b5649.svg";